import { IMG_URL } from '@/app/config'
import React from 'react'

const AwardCard = ({ name, designation, detail, img ,yer}) => {
    return (
        <>
            <div className='col'>
                <div className="award-card">
                    <div className="award-img">
                        <img src={`${IMG_URL}${img}`} alt="Awardee" />
                    </div>
                    <div className="award-content">
                        <div className="award-name">{name}</div>
                        <div className="award-role">{designation}</div>
                        <div className="award-detail">
                            {detail}<br/>{yer}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AwardCard
